var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dropdown',{attrs:{"width-auto":"","auto-close":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('font-awesome-icon',{attrs:{"size":"xs","icon":"bars"}})],1),_c('sidebar',{attrs:{"slot":"content","elevated":""},slot:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }